module.exports = __webpack_public_path__ + "assets/img/mastercard@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/mastercard@2x.png
// module id = 136
// module chunks = 0